const formatWithPrecision = (value, precision = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return value;
  }
  const num = Number(value);
  const formatted = num.toFixed(precision);
  return parseFloat(formatted).toString();
};

const formatNumber = (value, precision = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return value;
  }

  // Calculate the multiplier based on precision
  const multiplier = Math.pow(10, precision);
  const rounded = Math.round(value * multiplier) / multiplier;

  // Check if it's effectively an integer
  if (rounded === Math.floor(rounded)) {
    return Math.floor(rounded);
  }

  return rounded;
};

export { formatWithPrecision, formatNumber };
